import { StyledVerticalScrollFade } from "./fade-vertical-scroll.styles";
import { MDSVerticalScrollFadeProps } from "./fade-vertical-scroll.types";

export const MDSFadeTop = ({
  visible = true,
  ...rest
}: Omit<MDSVerticalScrollFadeProps, "placement">) => (
  <StyledVerticalScrollFade
    data-mds-name="fade-top"
    $placement="top"
    $visible={visible}
    aria-hidden
    {...rest}
  />
);
